import React, { useState } from "react";
import EnadActivityItem from "./EnadActivityItem";

function ActivitySelectorRefactor({ enadActivities, onSelectActivities, selectedKnowledgeArea }) {
  const [initActivity, setInitActivity] = useState("");
  const [developActivity, setDevelopActivity] = useState("");
  const [closeActivity, setCloseActivity] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = () => {
    const prepareContent = `
    ---
      Estructura de sesión ENAd
      Inicio: ${initActivity}
      Desarrollo: ${developActivity}
      Cierre:${closeActivity}
    ---
    `;

    if (initActivity === "" || developActivity === "" || closeActivity === "") {
      setErrorMessage("Por favor selecciona una actividad para cada sección");
      return;
    }
    onSelectActivities(prepareContent);
  };

  const onSelectActivity = (title, activity) => {
    if (title === "Inicio") {
      setInitActivity(activity.name);
    }
    if (title === "Desarrollo") {
      setDevelopActivity(activity.name);
    }
    if (title === "Cierre") {
      setCloseActivity(activity.name);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="text-shaiaBlue text-center font-bold text-lg">
        Estructura de sesión ENAd
      </div>
      <EnadActivityItem
        knowledgeArea={selectedKnowledgeArea}
        list={enadActivities}
        title="Inicio"
        customContainerClass="border-shaiaBlue"
        customContainerTitleClass="text-shaiaBlue"
        onSelectActivity={onSelectActivity}
        blackList={[developActivity, closeActivity]}
        conditionTime={10}
      />
      <EnadActivityItem
        knowledgeArea={selectedKnowledgeArea}
        list={enadActivities}
        title="Desarrollo"
        customContainerClass=" border-Yellow-500"
        customContainerTitleClass="text-Yellow-500"
        onSelectActivity={onSelectActivity}
        blackList={[initActivity, closeActivity]}
        conditionTime={25}
        isGreaterOrEqual
      />

      <EnadActivityItem
        knowledgeArea={selectedKnowledgeArea}
        list={enadActivities}
        title="Cierre"
        customContainerClass="border-shaiaGreen "
        customContainerTitleClass="text-shaiaGreen"
        onSelectActivity={onSelectActivity}
        blackList={[initActivity, developActivity]}
        conditionTime={10}
      />
      <div className="text-Red-500 font-bold text-center">{errorMessage}</div>
      <div className="flex justify-center mt-2">
        <button
          className="bg-shaiaBlue text-DarkBlue-500 p-3 rounded-md font-bold"
          onClick={onSubmit}
        >
          Guardar
        </button>
      </div>
    </div>
  );
}

export default ActivitySelectorRefactor;
